// utils/trimPdfClient.js
import { PDFDocument } from 'pdf-lib';

export async function trimPdfClient(file, maxPages = 10) {
  const arrayBuffer = await file.arrayBuffer();

  const sourcePdf = await PDFDocument.load(arrayBuffer);
  const totalPages = sourcePdf.getPageCount();

  const targetPdf = await PDFDocument.create();

  const pagesToCopy = Math.min(totalPages, maxPages);

  const copiedPages = await targetPdf.copyPages(
    sourcePdf,
    Array.from({ length: pagesToCopy }, (_, i) => i)
  );

  copiedPages.forEach((page) => targetPdf.addPage(page));

  const trimmedBytes = await targetPdf.save();

  return new File([trimmedBytes], file.name.replace(/\.pdf$/i, `-first-${pagesToCopy}-pages.pdf`), {
    type: 'application/pdf',
  });
}
